<template>
    <div
        class="row"
        :class="$style.row"
    >
        <div class="d-none d-xl-flex col-6">
            <img
                src="@/system/assets/images/public/user.png"
                class="img-fluid mx-auto"
            >
        </div>
        <div class="col-xl-6 col-lg-12">
            <validation-observer v-slot="{ passes, invalid }">
                <form @submit.prevent="passes(save)">
                    <div
                        class="card"
                        :class="$style.card"
                    >
                        <div class="card-body">
                            <div :class="$style.avatar">
                                <g-avatar
                                    :user="user"
                                    :size="100"
                                    shape="circle"
                                />
                            </div>

                            <h5 class=" mt-2 mb-3">
                                <strong>General</strong>
                            </h5>

                            <div class="row ">
                                <div class="col-lg-6">
                                    <validation-provider
                                        v-slot="slotProps"
                                        rules="required|_userNick"
                                    >
                                        <a-form-item
                                            label="Nick"
                                            has-feedback
                                            :validate-status="$utils.resolveState(slotProps)"
                                            :help="slotProps.errors[0]"
                                        >
                                            <a-input
                                                v-model="fields.nick"
                                                placeholder="Nick"
                                                :max-length="20"
                                            />
                                        </a-form-item>
                                    </validation-provider>
                                </div>
                                <div class="col-lg-6">
                                    <validation-provider
                                        v-slot="slotProps"
                                        rules="required|email"
                                    >
                                        <a-form-item
                                            label="Email"
                                            has-feedback
                                            :validate-status="$utils.resolveState(slotProps)"
                                            :help="slotProps.errors[0]"
                                        >
                                            <a-input
                                                v-model="fields.email"
                                                placeholder="Email"
                                                :max-length="360"
                                            />
                                        </a-form-item>
                                    </validation-provider>
                                </div>
                            </div>

                            <hr class="py-2">

                            <h5 class=" mt-2 mb-3">
                                <strong>Información personal</strong>
                            </h5>
                            <div class="row">
                                <div class="col-lg-6">
                                    <a-form-item label="Nombre">
                                        <a-input
                                            v-model="fields.name"
                                            placeholder="Nombre"
                                            :max-length="100"
                                        />
                                    </a-form-item>
                                </div>
                                <div class="col-lg-6">
                                    <a-form-item label="Teléfono">
                                        <a-input
                                            v-model="fields.phone"
                                            placeholder="Teléfono"
                                            :max-length="50"
                                        />
                                    </a-form-item>
                                </div>
                            </div>

                            <hr class="py-2">

                            <h5 class=" mt-2 mb-3">
                                <strong>{{ id ? 'Nueva ' : '' }}Contraseña</strong>
                            </h5>

                            <div class="row">
                                <div class="col-lg-6">
                                    <validation-provider
                                        v-slot="slotProps"
                                        rules="_userPassword|password:@confirm"
                                    >
                                        <a-form-item
                                            label="Contraseña"
                                            has-feedback
                                            :validate-status="$utils.resolveState(slotProps)"
                                            :help="slotProps.errors[0]"
                                        >
                                            <a-input
                                                ref="password"
                                                v-model="fields.password"
                                                type="password"
                                                placeholder="Contraseña"
                                            />
                                        </a-form-item>
                                    </validation-provider>
                                </div>
                                <div class="col-lg-6">
                                    <validation-provider
                                        v-slot="slotProps"
                                        name="confirm"
                                        rules="_userPassword"
                                    >
                                        <a-form-item
                                            label="Confirma tu contraseña"
                                            has-feedback
                                            :validate-status="$utils.resolveState(slotProps)"
                                            :help="slotProps.errors[0]"
                                        >
                                            <a-input
                                                ref="password2"
                                                v-model="fields.password2"
                                                type="password"
                                                placeholder="Repite la contraseña"
                                            />
                                        </a-form-item>
                                    </validation-provider>
                                </div>
                            </div>

                            <template v-if="isAdmin">
                                <hr class="py-2">

                                <div class="row">
                                    <div class="col-lg-6">
                                        <h5 class=" mt-2 mb-3">
                                            <strong>Grupo</strong>
                                        </h5>
                                        <a-form-item>
                                            <a-select
                                                v-model="fields.group"
                                                show-search
                                                placeholder="Selecciona un grupo"
                                                option-filter-prop="children"
                                            >
                                                <a-select-option :value="'0'">
                                                    Ninguno
                                                </a-select-option>

                                                <a-select-option
                                                    v-for="(item, i) in groups"
                                                    :key="i"
                                                    :value="item.ID"
                                                >
                                                    {{ item.Name }}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div class="card-footer text-right">
                            <a-button
                                type="primary"
                                html-type="submit"
                                class="mr-3"
                                :loading="loading"
                                :disabled="invalid"
                            >
                                Guardar
                            </a-button>
                            <a-button @click="$router.back()">
                                Cancelar
                            </a-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SystemUsersForm',
    data() {
        return {
            user: null,
            groups: [],
            id: null,
            loading: false,
            fields: {
                nick: '',
                name: '',
                email: '',
                phone: '',
                group: '0',
                password: '',
                password2: ''
            }
        }
    },
    computed: {
        isAdmin() {
            return this.$gestios.auth.check({ scopes: ['_BOSS'] })
        }
    },
    watch: {
        '$route.params.id': async function (id) {
            this.getUser(id)
        }
    },
    async created() {
        this.listGroups()

        if (this.$route.params.id) this.getUser(this.$route.params.id)
    },
    methods: {
        // GET USER
        async getUser(id) {
            this.id = id

            if (this.$gestios.profile.ID === id || this.$gestios.profile.BOSS === '1') {
                const user = await this.$gestios.users.get(id)

                if (user.ok) {
                    this.user = user.data

                    this.fields = {
                        nick: this.user.Nick,
                        name: this.user.Name,
                        email: this.user.Email,
                        phone: this.user.Phone,
                        group: this.user.Group && this.user.Group.ID > 0 ? this.user.Group.ID : '0',
                        password: '',
                        password2: ''
                    }
                } else {
                    this.$router.replace({ name: '_404' })
                }
            } else {
                this.$router.replace({ name: '_403' })
            }
        },
        // LIST GROUPS
        async listGroups() {
            if (this.isAdmin) {
                const result = await this.$gestios.groups.list()
                if (result.ok) this.groups = result.data
            }
        },
        // FILTER GROUPS
        filterGroups(input, option) {
            const data = option.componentOptions.children[0].text.toLowerCase()
            return data.indexOf(input.toLowerCase()) >= 0
        },
        // ADD/EDIT USER
        async save() {
            this.loading = true

            if (this.id) {
                const params = {
                    id: this.user.ID,
                    email: this.fields.email,
                    nick: this.fields.nick,
                    name: this.fields.name,
                    phone: this.fields.phone,
                    group: this.fields.group !== '0' ? this.fields.group : null,
                    password: this.fields.password.trim() !== '' ? this.fields.password : null
                }

                const edit = await this.$gestios.users.edit(params)

                if (edit.ok) {
                    this.$message.success('Perfil editado correctamente')

                    const { data } = edit

                    if (this.user.ID === this.$gestios.profile.ID) {
                        this.$store.commit('GESTIOS/AUTH/EDIT', {
                            email: data.Email,
                            nick: data.Nick,
                            name: data.Name,
                            phone: data.Phone,
                            group: data.Group
                        })
                    }

                    this.$router.push({ name: '_users' })
                }

                this.loading = false
            } else {
                const params = {
                    email: this.fields.email,
                    nick: this.fields.nick,
                    name: this.fields.name,
                    phone: this.fields.phone,
                    password: this.fields.password.trim() !== '' ? this.fields.password : null
                }

                if (this.fields.group) params.group = this.fields.group

                const add = await this.$gestios.users.add(params)

                if (add.ok) {
                    this.$message.success('Usuario creado correctamente')
                    this.$router.push({ name: '_users' })
                }

                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss" module>
.row {
    height: 100%;
    display: flex;
    align-items: center;
}

.card {
    margin-top: 60px;
    margin-bottom: 0;
}

.avatar {
    width: 100%;
    text-align: center;
    margin-top: -75px;

    img {
        background: white;
    }
}
</style>
